/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Row, Col, Table, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import filter from 'lodash/filter';
import find from 'lodash/find';
import {
  faChevronLeft,
  faImagePolaroid,
  faList,
  faThLarge,
} from '@fortawesome/pro-solid-svg-icons';
import { parseISO, format } from 'date-fns';
import { apiGet } from '../../../../api';
import { useStorageInventory } from '../../inventory/queries';
import { InventoryGridView } from '../../inventory/InventoryGridView';
import LoadingPlaceHolder from '../../../../components/LoadingPlaceHolder';

function StoragePickListDetail() {
  const [isGridView, setIsGridView] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(false);

  const { id } = useParams();
  const [pickList, setPickList] = useState([]);
  const [isPickListDataFetched, setIsPickListDataFetched] = useState(false);
  const { data: allInventoryItems } = useStorageInventory();
  const inventories = filter(
    allInventoryItems,
    (inventoryItem) => id === inventoryItem.PickListID
  );
  const date = pickList ? parseISO(pickList.RequestedDate) : '';

  useEffect(() => {
    (async () => {
      const result = await apiGet('storage/inventory/picklists/all');
      const lists = await result.json();
      const currentList = find(lists, (list) => list.PickListID === id);
      setPickList(currentList);
      setIsPickListDataFetched(true);
    })();
  }, []);

  const handleSelectedItemId = (newItem) => {
    if (selectedItemId === newItem) {
      setSelectedItemId(false);
      return;
    }
    setSelectedItemId(newItem);
  };

  return (
    <div className="portal-inner has-tabs">
      <Link to="/portal/storage/pick-lists" className="back-link">
        <FontAwesomeIcon icon={faChevronLeft} />
        Return to Pick Lists
      </Link>
      <Row>
        <Col xl={9}>
          {pickList && (
            <div className="info-box">
              <div className="info-header">
                <h3>{pickList.PickListName}</h3>
              </div>
              <div className="info-content">
                <LoadingPlaceHolder isVisible={!isPickListDataFetched} />
                {isPickListDataFetched && (
                  <Row>
                    <Col md={6} lg={3}>
                      <label>Requested Date</label>
                      <div>{format(date, 'M/dd/yy')}</div>
                    </Col>
                    <Col md={6} lg={3}>
                      <label>Deliver To</label>
                      <div>
                        {pickList.Address} {pickList.Address2}
                        <br />
                        {pickList.City}, {pickList.State} {pickList.Zip}
                      </div>
                    </Col>
                    <Col md={6} lg={3}>
                      <label>No. of Items</label>
                      <div>{inventories.length}</div>
                    </Col>
                    <Col md={6} lg={3}>
                      <label>Status</label>
                      <div>
                        <Badge bg="warning text-body">Submitted</Badge>
                        {/* <Badge bg="success">Completed</Badge> */}
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          )}

          <div className="info-box">
            <div className="info-header">
              <h3>Item List</h3>
              <div className="layout-toggle">
                <a
                  href="#"
                  onClick={(event) => {
                    setIsGridView(false);
                    event.preventDefault();
                  }}
                  className={`layout-list ${!isGridView ? 'active' : ''}`}
                >
                  <FontAwesomeIcon color="white" icon={faList} size="lg" />
                </a>{' '}
                <a
                  href="#"
                  onClick={(event) => {
                    setIsGridView(true);
                    event.preventDefault();
                  }}
                  className={`layout-grid ${isGridView ? 'active' : ''}`}
                >
                  <FontAwesomeIcon color="white" icon={faThLarge} size="lg" />
                </a>
              </div>
            </div>

            {inventories && isGridView && (
              <div className="p-3">
                <InventoryGridView
                  currentPageInventoryItems={inventories}
                  hideActions
                  handleAddToPickList
                  isItemInDraftPickList
                />
              </div>
            )}

            {inventories && !isGridView && (
              <div className="info-content">
                <Table className="table-borderless" responsive>
                  <thead>
                    <tr>
                      <th width="4%" />
                      <th>Item No.</th>
                      <th>Item Name</th>
                      <th>Ship No.</th>
                      <th width="50%">Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inventories &&
                      inventories.map((inventory) => (
                        <>
                          <tr>
                            <td>
                              <FontAwesomeIcon
                                icon={faImagePolaroid}
                                size="lg"
                                className="text-primary"
                                onClick={() =>
                                  handleSelectedItemId(
                                    inventory.InventoryItemID
                                  )
                                }
                              />
                            </td>
                            <td>{inventory.ItemTag}</td>
                            <td>{inventory.ItemName}</td>
                            <td>{inventory.ShipmentNumber}</td>
                            <td>{inventory.Comments}</td>
                          </tr>
                          {inventory.InventoryItemID === selectedItemId && (
                            <tr>
                              <td colSpan="5" className="p-0">
                                <div
                                  className="info py-5 px-3"
                                  id="inventory-grid-col-1"
                                >
                                  <Row>
                                    <Col md={6} lg={3}>
                                      <img
                                        src={inventory.ili[0].FirstImage}
                                        alt=""
                                      />
                                    </Col>
                                    <Col md={6} lg={3}>
                                      <div className="h3 fw-normal">
                                        {inventory.ItemName}
                                      </div>
                                      {inventory.ItemTag}
                                    </Col>
                                    <Col md={6} lg={3}>
                                      <Row>
                                        <Col sm={6}>
                                          <div className="fw-bold">
                                            Shipment
                                          </div>
                                          {inventory.ShipmentNumber}
                                        </Col>
                                        <Col sm={6}>
                                          <div className="fw-bold">Room</div>
                                          {inventory.RoomName}
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md={6} lg={3}>
                                      <div className="fw-bold">Comments</div>
                                      {inventory.Comments}
                                    </Col>
                                  </Row>
                                </div>
                              </td>
                            </tr>
                          )}
                        </>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StoragePickListDetail;
